import { render, staticRenderFns } from "./docLoading.vue?vue&type=template&id=3b413f4c"
import script from "./docLoading.vue?vue&type=script&lang=js"
export * from "./docLoading.vue?vue&type=script&lang=js"
import style0 from "./docLoading.vue?vue&type=style&index=0&id=3b413f4c&prod&slot=scoped&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports